export default __webpack_public_path__ + "static/media/alarm.512fa7fc.webp";